import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

import LoginPage from './login/LoginPage';
import HomePage from './home/HomePage';
import Courses from './courses/Courses';
import Profile from './profile/Profile';
import Subjects from './subjects/Subjects';
import Notes from './notes/Notes';
import Contact from './contact/Contact';
import Students from './students/Students';
import OnlineClass from './onlineClass/OnlineClass';
import NotFound from './notfound/NotFound';
import UpdateClass from './updateData/UpdateClass';
import UpdateNotes from './updateData/UpdateNotes';
import UpdateCourse from './updateData/UpdateCourse';
import EnrolledCourses from './students/EnrolledCourses';
import CoursePageId from './courses/CoursePageId';
import Sections from './courses/Sections';
import EditSection from './courses/EditSection';

const App = () => {
  const [loggedIn, setLoggedIn] = useState(null);

  useEffect(() => {
    const loggedUser = localStorage.getItem('user');
    setLoggedIn(Boolean(loggedUser));
  }, []);

  const handleLoggedIn = () => {
    setLoggedIn(true);
  };

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        setLoggedIn(false);
        localStorage.clear();
      } else if (result.isDenied) {
        Swal.fire('Welcome back!', '', 'info');
      }
    });
  };

  return (
    <div>
      {loggedIn !== null && (
        <Router>
          <Switch>
            <Route exact strict path='/'>
              {!loggedIn ? (
                <LoginPage handleLoggedIn={handleLoggedIn} />
              ) : (
                <Redirect to='/home' />
              )}
            </Route>
            <Route exact path='/home'>
              <HomePage handleLogout={handleLogout} loggedIn={loggedIn} />
            </Route>
            <Route exact path='/profile'>
              <Profile loggedIn={loggedIn} handleLogout={handleLogout} />
            </Route>
            <Route exact path='/subjects'>
              <Subjects loggedIn={loggedIn} handleLogout={handleLogout} />
            </Route>
            <Route exact path='/courses'>
              <Courses loggedIn={loggedIn} handleLogout={handleLogout} />
            </Route>
            <Route exact path='/notes'>
              <Notes loggedIn={loggedIn} handleLogout={handleLogout} />
            </Route>
            <Route exact path='/contact'>
              <Contact loggedIn={loggedIn} handleLogout={handleLogout} />
            </Route>
            <Route exact path='/students'>
              <Students loggedIn={loggedIn} handleLogout={handleLogout} />
            </Route>
            <Route exact path='/class'>
              <OnlineClass loggedIn={loggedIn} handleLogout={handleLogout} />
            </Route>

            <Route exact path='/class/update/:id'>
              {!loggedIn ? (
                <LoginPage handleLoggedIn={handleLoggedIn} />
              ) : (
                <UpdateClass />
              )}
            </Route>
            <Route exact path='/notes/update/:id'>
              {!loggedIn ? (
                <LoginPage handleLoggedIn={handleLoggedIn} />
              ) : (
                <UpdateNotes />
              )}
            </Route>
            <Route exact path='/students/:id'>
              {!loggedIn ? (
                <LoginPage handleLoggedIn={handleLoggedIn} />
              ) : (
                <EnrolledCourses />
              )}
            </Route>
            <Route exact path='/courses/:id'>
              {!loggedIn ? (
                <LoginPage handleLoggedIn={handleLoggedIn} />
              ) : (
                <CoursePageId />
              )}
            </Route>
            <Route exact path='/courses/edit/:id'>
              {!loggedIn ? (
                <LoginPage handleLoggedIn={handleLoggedIn} />
              ) : (
                <UpdateCourse />
              )}
            </Route>
            <Route exact path='/courses/section/:id'>
              {!loggedIn ? (
                <LoginPage handleLoggedIn={handleLoggedIn} />
              ) : (
                <Sections />
              )}
            </Route>
            <Route exact path='/courses/section/edit/:id'>
              {!loggedIn ? (
                <LoginPage handleLoggedIn={handleLoggedIn} />
              ) : (
                <EditSection />
              )}
            </Route>
            <Route>
              <NotFound />
            </Route>
          </Switch>
        </Router>
      )}
    </div>
  );
};

export default App;
